import React from 'react';
import GaugeChart from 'react-gauge-chart';

const Meter = ({ max, value }) => {
  // Calculamos el porcentaje de consumo
  const percentage = (value * 100) / max;

  return (
    <div className="w-full h-full flex items-center mx-auto">
      <GaugeChart
        id="gauge-chart2"
        nrOfLevels={10} 
        arcPadding={0} 
        cornerRadius={0} 
        colors={['#5BE12C', '#F5CD19', '#EA4228']}
        animate
        needleColor="#000"
        needleBaseColor="#000"
        style={{ width: '100%' }}
        percent={percentage / 100}
        textColor="black"
        // Mostrar el consumo de energía en kWh en lugar del porcentaje
        formatTextValue={(value) => `${value * max} kWh`}
      />
    </div>
  );
};

export default Meter;